import {
  COVERAGE_FILL_CLASS,
  COVERAGE_LABEL,
  COVERAGE_STATES,
  type CoverageState,
} from "./coverage";

const SWATCH_SIZE_CLASS = { xs: "size-1.5", sm: "size-2", md: "size-3" };

/** The key mark for one state: filled, or an outline for "no documented support". */
export function CoverageSwatch({
  state,
  size = "sm",
}: {
  state: CoverageState;
  size?: keyof typeof SWATCH_SIZE_CLASS;
}) {
  return (
    <span
      aria-hidden={true}
      className={`${SWATCH_SIZE_CLASS[size]} shrink-0 rounded-full ${
        state === "none"
          ? "border border-(--border-strong)"
          : COVERAGE_FILL_CLASS[state]
      }`}
    />
  );
}

/** The legend for every coverage chart, so the key reads the same everywhere. */
export function CoverageLegend() {
  return (
    <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 px-1">
      {COVERAGE_STATES.map((state) => (
        <li
          key={state}
          className="flex items-center gap-2 text-[12px] text-(--fg-secondary)"
        >
          <CoverageSwatch state={state} size="md" />
          {COVERAGE_LABEL[state]}
        </li>
      ))}
    </ul>
  );
}
